// Assessment Section Codes
export const ASSESSMENT_SECTION_CL001_CODES = {
  ADLS_FUNCTIONAL_NEEDS: {
    CODE: "CL001.27",
    VALUE: "ADL's Functional Needs",
    DESCRIPTION: "ADL's Functional Needs",
    REF_KEY: "adlsFunctionalNeeds",
  },
  ASSESSMENT_GENERAL: {
    CODE: "CL001.32",
    VALUE: "Assessment- General",
    DESCRIPTION: "Assessment- General",
    REF_KEY: "assessmentGeneral",
  },
  BEREAVEMENT: {
    CODE: "CL001.20",
    VALUE: "Bereavement",
    DESCRIPTION: "Bereavement",
    REF_KEY: "bereavement",
  },
  BILLING: {
    CODE: "CL001.29",
    VALUE: "Billing",
    DESCRIPTION: "Billing",
    REF_KEY: "billing",
  },
  BRIEF: {
    CODE: "CL001.1",
    VALUE: "Brief",
    DESCRIPTION: "Brief",
    REF_KEY: null,
  },
  CARDIOVASCULAR: {
    CODE: "CL001.8",
    VALUE: "Cardiovascular",
    DESCRIPTION: "Cardiovascular",
    REF_KEY: "cardiovascular",
  },
  POST_MORTEM_ENCOUNTER_DEATH_ASSESSMENT: {
    CODE: "CL001.37",
    VALUE: "Death Assessment",
    DESCRIPTION: "Death Assessment",
    REF_KEY: "deathAssessment",
  },
  EVAL_1: {
    CODE: "CL001.33",
    VALUE: "Eval 1",
    DESCRIPTION: "Eval 1",
    REF_KEY: "eval1",
  },
  EXTERNAL_FACE_TO_FACE: {
    CODE: "CL001.38",
    VALUE: "External Face to Face",
    DESCRIPTION: "External Face to Face",
    REF_KEY: "faceToFaceExternal",
  },
  FACE_TO_FACE_MD: {
    CODE: "CL001.28",
    VALUE: "Face to Face MD",
    DESCRIPTION: "Face to Face MD",
    REF_KEY: "faceToFaceMD",
  },
  FACE_TO_FACE_NURSE: {
    CODE: "CL001.17",
    VALUE: "Face to Face Nurse",
    DESCRIPTION: "Face to Face Nurse",
    REF_KEY: "faceToFace",
  },
  GASTROINTESTINAL: {
    CODE: "CL001.9",
    VALUE: "Gastrointestinal",
    DESCRIPTION: "Gastrointestinal",
    REF_KEY: "gastrointestinal",
  },
  GENITOURINARY: {
    CODE: "CL001.10",
    VALUE: "Genitourinary",
    DESCRIPTION: "Genitourinary",
    REF_KEY: "genitourinary",
  },
  HIS: {
    CODE: "CL001.25",
    VALUE: "HIS",
    DESCRIPTION: "HIS",
    REF_KEY: "his",
  },
  HOMEMAKER: {
    CODE: "CL001.22",
    VALUE: "Homemaker",
    DESCRIPTION: "Homemaker",
    REF_KEY: "homemaker",
  },
  HOSPICE_AIDE: {
    CODE: "CL001.21",
    VALUE: "Hospice Aide",
    DESCRIPTION: "Hospice Aide",
    REF_KEY: "hospiceAide",
  },
  HOSPICE_AIDE_CARE_PLAN: {
    CODE: "CL001.30",
    VALUE: "Hospice Aide Care Plan",
    DESCRIPTION: "Hospice Aide Care Plan",
    REF_KEY: "hospiceAideHACarePlan",
  },
  HOSPICE_AIDE_CARE_PLAN_RN: {
    CODE: "CL001.35",
    VALUE: "Hospice Aide Care Plan RN",
    DESCRIPTION: "Hospice Aide Care Plan RN",
    REF_KEY: "hospiceAideHACarePlanRN",
  },
  LEVEL_OF_CARE: {
    CODE: "CL001.2",
    VALUE: "Level of Care",
    DESCRIPTION: "Level of Care",
    REF_KEY: "levelOfCare",
  },
  MILITARY_HISTORY: {
    CODE: "CL001.31",
    VALUE: "Military History",
    DESCRIPTION: "Military History",
    REF_KEY: "militaryHistory",
  },
  MUSCULOSKELETAL: {
    CODE: "CL001.13",
    VALUE: "Musculoskeletal",
    DESCRIPTION: "Musculoskeletal",
    REF_KEY: "musculoskeletal",
  },
  NEUROLOGICAL: {
    CODE: "CL001.5",
    VALUE: "Neurological",
    DESCRIPTION: "Neurological",
    REF_KEY: "neurological",
  },
  NUTRITION_METABOLIC: {
    CODE: "CL001.11",
    VALUE: "Nutrition/Metabolic",
    DESCRIPTION: "Nutrition/Metabolic",
    REF_KEY: "nutritionalMetabolic",
  },
  PAIN: {
    CODE: "CL001.6",
    VALUE: "Pain",
    DESCRIPTION: "Pain",
    REF_KEY: "pain",
  },
  PRECAUTIONS_SAFETY_TEACHINGS: {
    CODE: "CL001.15",
    VALUE: "Precautions/Safety and Teachings",
    DESCRIPTION: "Precautions/Safety and Teachings",
    REF_KEY: "precautionsSafetyTeachings",
  },
  PREFERENCES: {
    CODE: "CL001.26",
    VALUE: "Preferences",
    DESCRIPTION: "Preferences",
    REF_KEY: "preferences",
  },
  RESPIRATORY: {
    CODE: "CL001.7",
    VALUE: "Respiratory",
    DESCRIPTION: "Respiratory",
    REF_KEY: "respiratory",
  },
  RISK_FACTORS: {
    CODE: "CL001.14",
    VALUE: "Risk Factors",
    DESCRIPTION: "Risk Factors",
    REF_KEY: null,
  },
  SKIN: {
    CODE: "CL001.12",
    VALUE: "Skin",
    DESCRIPTION: "Skin",
    REF_KEY: "skin",
  },
  SOCIAL_WORK: {
    CODE: "CL001.18",
    VALUE: "Social Work",
    DESCRIPTION: "Social Work",
    REF_KEY: "socialWork",
  },
  SOCIAL_WORKER_SUPERVISORY_VISIT: {
    CODE: "CL001.34",
    VALUE: "Social Supervisory Visit",
    DESCRIPTION: "Social Worker Supervisory Visit",
    REF_KEY: "socialSupervisoryVisit",
  },
  SPIRITUAL_CARE: {
    CODE: "CL001.19",
    VALUE: "Spiritual Care",
    DESCRIPTION: "Spiritual Care",
    REF_KEY: "spiritualCare",
  },
  SUMMARY_COORDINATION_OF_CARE: {
    CODE: "CL001.23",
    VALUE: "Summary Coordination of Care",
    DESCRIPTION: "Summary Coordination of Care",
    REF_KEY: "summary",
  },
  SUPERVISORY_VISIT: {
    CODE: "CL001.16",
    VALUE: "Supervisory Visit",
    DESCRIPTION: "Supervisory Visit",
    REF_KEY: "supervisoryVisit",
  },
  SYMPTOM_SUMMARY: {
    CODE: "CL001.36",
    VALUE: "Symptom Summary",
    DESCRIPTION: "Symptom Summary",
    REF_KEY: "symptomSummary",
  },
  SYMPTOMS_GIP_REASONS: {
    CODE: "CL001.3",
    VALUE: "Symptoms/GIP Reasons",
    DESCRIPTION: "Symptoms/GIP Reasons",
    REF_KEY: null,
  },
  VITALS: {
    CODE: "CL001.4",
    VALUE: "Vitals",
    DESCRIPTION: "Vitals",
    REF_KEY: "vitals",
  },
  VOLUNTEER: {
    CODE: "CL001.24",
    VALUE: "Volunteer",
    DESCRIPTION: "Volunteer",
    REF_KEY: "volunteer",
  },
} as const;

// Assessment Type Codes (CL003.x)
export const ASSESSMENT_TYPE_CL003_CODES = {
  COMPREHENSIVE_ASSESSMENT: {
    CODE: "CL003.2",
    VALUE: "Comprehensive Assessment",
    DESCRIPTION: "Comprehensive Assessment",
    REF_KEY: null,
  },
  ROUTINE: {
    CODE: "CL003.3",
    VALUE: "Routine",
    DESCRIPTION: "Routine",
    REF_KEY: null,
  },
  FACE_TO_FACE: {
    CODE: "CL003.4",
    VALUE: "Face to Face Visit",
    DESCRIPTION: "Face to Face Visit",
    REF_KEY: null,
  },
  CONTINUOUS_CARE: {
    CODE: "CL003.5",
    VALUE: "Continuous Care Visits",
    DESCRIPTION: "Continuous Care Visits",
    REF_KEY: null,
  },
  EMERGENT: {
    CODE: "CL003.6",
    VALUE: "Emergent",
    DESCRIPTION: "Emergent",
    REF_KEY: null,
  },
  IN_PATIENT: {
    CODE: "CL003.7",
    VALUE: "In-Patient",
    DESCRIPTION: "In-Patient",
    REF_KEY: null,
  },
  WATCH_CARE: {
    CODE: "CL003.8",
    VALUE: "Watch Care Visit",
    DESCRIPTION: "Watch Care Visit",
    REF_KEY: null,
  },
  PHONE_CALL: {
    CODE: "CL003.10",
    VALUE: "Phone Call",
    DESCRIPTION: "Phone Call",
    REF_KEY: null,
  },
  INITIAL_COMPREHENSIVE_ASSESSMENT: {
    CODE: "CL003.1",
    VALUE: "Initial/Comprehensive Assessment",
    DESCRIPTION: "Initial/Comprehensive Assessment",
    REF_KEY: null,
  },
  HOSPITAL: {
    FOLLOW_UP: {
      CODE: "CL003.18",
      VALUE: "Follow Up Visit - Hospital",
      DESCRIPTION: "Follow Up Visit",
      REF_KEY: null,
    },
    INITIAL_VISIT: {
      CODE: "CL003.20",
      VALUE: "Initial Visit - Hospital",
      DESCRIPTION: "Initial Visit",
      REF_KEY: null,
    },
  },
  PHYSICIANS_OFFICE: {
    CODE: "CL003.19",
    VALUE: "Physician's Office",
    DESCRIPTION: "Physician's Office",
    REF_KEY: null,
  },
  EVALUATION_ASSESSMENT: {
    CODE: "CL003.26",
    VALUE: "Evaluation Assessment",
    DESCRIPTION: "Evaluation Assessment",
    REF_KEY: null,
  },
  SOCIAL_WORKER: {
    SUPERVISORY_VISIT: {
      CODE: "CL003.27",
      VALUE: "Supervisory Visit",
      DESCRIPTION: "Master Social Worker Supervisory Visit",
      REF_KEY: null,
    },
    VISIT: {
      CODE: "CL003.25",
      VALUE: "Social Worker Visit",
      DESCRIPTION: "Social Worker Visit",
      REF_KEY: null,
    },
  },
  HOSPICE_AIDE_ROUTINE: {
    CODE: "CL003.28",
    VALUE: "Hospice Aide Routine",
    DESCRIPTION: "Hospice Aide Routine",
    REF_KEY: null,
  },
  HOME_ASSISTED_LIVING: {
    NEW_PATIENT: {
      CODE: "CL003.29",
      VALUE: "New Patient - Home/Assisted Living",
      DESCRIPTION: "New Patient - Home/Assisted Living",
      REF_KEY: null,
    },
    ESTABLISHED_PATIENT: {
      CODE: "CL003.30",
      VALUE: "Established Patient - Home/Assisted Living",
      DESCRIPTION: "Established Patient - Home/Assisted Living",
      REF_KEY: null,
    },
  },
  NURSING_HOME_SKILLED_NURSING: {
    NEW_PATIENT: {
      CODE: "CL003.31",
      VALUE: "New Patient - Nursing Home/Skilled Nursing",
      DESCRIPTION: "New Patient - Nursing Home/Skilled Nursing",
      REF_KEY: null,
    },
    ESTABLISHED_PATIENT: {
      CODE: "CL003.32",
      VALUE: "Established Patient - Nursing Home/Skilled Nursing",
      DESCRIPTION: "Established Patient - Nursing Home/Skilled Nursing",
      REF_KEY: null,
    },
  },
  NURSING_HOME: {
    NEW_PATIENT: {
      CODE: "CL003.23",
      VALUE: "New Patient- Nursing Home",
      DESCRIPTION: "New Patient- Nursing Home",
      REF_KEY: "newpatientnursinghome",
    },
    ESTABLISHED_PATIENT: {
      CODE: "CL003.21",
      VALUE: "Established Patient- Nursing Home",
      DESCRIPTION: "Established Patient- Nursing Home",
      REF_KEY: "establishedpatientnursinghome",
    },
  },
  HOME: {
    NEW_PATIENT: {
      CODE: "CL003.24",
      VALUE: "New Patient- Home",
      DESCRIPTION: "New Patient- Home",
      REF_KEY: "newpatienthome",
    },
    ESTABLISHED_PATIENT: {
      CODE: "CL003.22",
      VALUE: "Established Patient- Home",
      DESCRIPTION: "Established Patient- Home",
      REF_KEY: "establishedpatienthome",
    },
  },
  SKILLED_NURSING_ASSISTED_LIVING_FACILITY: {
    NEW_PATIENT: {
      CODE: "CL003.15",
      VALUE: "New Patient - Skilled Nursing Facility/Assisted Living Facility",
      DESCRIPTION:
        "New Patient - Skilled Nursing Facility/Assisted Living Facility",
      REF_KEY: null,
    },
    ESTABLISHED_PATIENT: {
      CODE: "CL003.16",
      VALUE:
        "Established Patient - Skilled Nursing Facility/Assisted Living Facility",
      DESCRIPTION:
        "Established Patient - Skilled Nursing Facility/Assisted Living Facility",
      REF_KEY: null,
    },
  },
  HOSPICE_HOUSE: {
    COMPREHENSIVE: {
      CODE: "CL003.13",
      VALUE: "Hospice House Comprehensive",
      DESCRIPTION: "Hospice House Comprehensive",
      REF_KEY: null,
    },
    ENCOUNTER: {
      CODE: "CL003.14",
      VALUE: "Hospice House Encounter",
      DESCRIPTION: "Hospice House Encounter",
      REF_KEY: null,
    },
  },
  POST_MORTEM_ENCOUNTER_DEATH_ASSESSMENT: {
    CODE: "CL003.33",
    VALUE: "Postmortem Encounter",
    DESCRIPTION: "Postmortem Encounter",
    REF_KEY: null,
  },
  EXTERNAL_FACE_TO_FACE: {
    CODE: "CL003.34",
    VALUE: "External Face to Face Visit",
    DESCRIPTION: "External Face to Face External",
    REF_KEY: null,
  },
  INITIAL_NURSING_ASSESSMENT: {
    CODE: "CL003.12",
    VALUE: "Initial Nursing Assessment",
    DESCRIPTION: "Initial Nursing Assessment",
    REF_KEY: null,
  },
  EMC: {
    CODE: "CL003.9",
    VALUE: "EMC",
    DESCRIPTION: "EMC",
    REF_KEY: null,
  },
  SUPERVISORY_VISIT: {
    CODE: "CL003.11",
    VALUE: "Supervisory Visit",
    DESCRIPTION: "Supervisory Visit",
    REF_KEY: null,
  },
  LCD: {
    CODE: "CL003.35",
    VALUE: "LCD",
    DESCRIPTION: "LCD",
    REF_KEY: null,
  },
} as const;

// Assessment Status Codes (CL004.x)
export const ASSESSMENT_STATUS_CL004_CODES = {
  SUBMITTED_TO_QA: {
    CODE: "CL004.6",
    VALUE: "Submitted to Qa",
    DESCRIPTION: "Submitted to Qa",
    REF_KEY: null,
  },
  QA_RETURNED: {
    CODE: "CL004.7",
    VALUE: "Qa Returned",
    DESCRIPTION: "Qa Returned",
    REF_KEY: null,
  },
  CREATED: {
    CODE: "CL004.1",
    VALUE: "Created",
    DESCRIPTION: "Created",
    REF_KEY: null,
  },
  IN_PROGRESS: {
    CODE: "CL004.2",
    VALUE: "In Progress",
    DESCRIPTION: "In Progress",
    REF_KEY: null,
  },
  NOT_STARTED: {
    CODE: "CL004.4",
    VALUE: "Not Started",
    DESCRIPTION: "Not Started",
    REF_KEY: null,
  },
  COMPLETED: {
    CODE: "CL004.3",
    VALUE: "Completed",
    DESCRIPTION: "Completed",
    REF_KEY: null,
  },
} as const;

// CO-3582: which visit statuses count as "open", per Design Rulings DR-14 and
// DR-25 (docs/PRD/CO-290-begin-next-visit-with-open-prior-visit/BDD-CO-3382.md).
// Note: the BDD's "Not Started" label means CL004.1 Created (Product renamed
// it 2026-08-06). CL004.4 "Not Started" is a distinct legacy code, also
// excluded from every set below.
export const OPEN_VISIT_STATUS_SETS = {
  // Open Visits view (CO-3456): listed statuses. DR-14 + DR-25.
  OPEN_FOR_VIEW: [
    ASSESSMENT_STATUS_CL004_CODES.IN_PROGRESS.CODE,
    ASSESSMENT_STATUS_CL004_CODES.SUBMITTED_TO_QA.CODE,
    ASSESSMENT_STATUS_CL004_CODES.QA_RETURNED.CODE,
  ] as string[],
  // Passive indicator (CO-3455): in-progress only. DR-14 includes Started,
  // excludes never-opened; QA-stage inclusion is NOT decided for the
  // indicator, so it is excluded until Product rules.
  OPEN_FOR_INDICATOR: [
    ASSESSMENT_STATUS_CL004_CODES.IN_PROGRESS.CODE,
  ] as string[],
  // Duplicate-start dialog (CO-3444): "still open" in the start-blocking
  // sense, mirroring the rule engine's blocking pair (changelog
  // 530-20260501-mh-add-lcd-not-blocker-all-active-rows.xml:
  // disallow_current_user_role_visit_open, statuses CL004.1 + CL004.2).
  OPEN_FOR_DUPLICATE_MATCH: [
    ASSESSMENT_STATUS_CL004_CODES.CREATED.CODE,
    ASSESSMENT_STATUS_CL004_CODES.IN_PROGRESS.CODE,
  ] as string[],
};

// Assessment Card Codes (CL010.x)
export const ASSESSMENT_CARD_CL010_CODES = {
  ADLS_FUNCTIONAL_NEEDS: {
    CODE: "CL010.122",
    VALUE: "ADL's Functional Needs",
    DESCRIPTION: "ADL's Functional Needs",
    REF_KEY: null,
    ADLS_FUNCTIONAL_NEEDS_ASSESSMENT: {
      CODE: "CL010.123",
      VALUE: "ADL's Functional Needs Assessment",
      DESCRIPTION:
        "ADL's Functional Needs --> ADL's Functional Needs Assessment",
      REF_KEY: null,
    },
    ACTIVITIES_OF_DAILY_LIVING_TIME_TO_TASK: {
      CODE: "CL010.125",
      VALUE: "Activities of Daily Living: Time to Task",
      DESCRIPTION:
        "ADL's Functional Needs --> Activities of Daily Living: Time to Task",
      REF_KEY: null,
    },
    ADDITIONAL_RECOMMENDED_THERAPY: {
      CODE: "CL010.126",
      VALUE: "Additional Recommended Therapy",
      DESCRIPTION: "ADL's Functional Needs --> Additional Recommended Therapy",
      REF_KEY: null,
    },
    DECLINE: {
      CODE: "CL010.239",
      VALUE: "Decline",
      DESCRIPTION: "ADL's Functional Needs --> Decline",
      REF_KEY: null,
    },
    DEPENDENT_FOR_ADLS: {
      CODE: "CL010.127",
      VALUE: "Dependent for ADLs",
      DESCRIPTION: "ADL's Functional Needs --> Dependent for ADLs",
      REF_KEY: null,
    },
    FUNCTIONAL_SCORING_TOOLS: {
      CODE: "CL010.124",
      VALUE: "Functional Scoring Tools",
      DESCRIPTION: "ADL's Functional Needs --> Functional Scoring Tools",
      REF_KEY: null,
    },
    SITUATIONAL_NOTES: {
      CODE: "CL010.128",
      VALUE: "Situational Notes",
      DESCRIPTION: "ADL's Functional Needs --> Situational Notes",
      REF_KEY: null,
    },
  },
  ALS: {
    CODE: "CL010.320",
    VALUE: "ALS",
    DESCRIPTION: "ALS",
    REF_KEY: null,
  },
  ASSESSMENT_GENERAL: {
    ADVANCE_CARE: {
      CODE: "CL010.304",
      VALUE: "Advance Care",
      DESCRIPTION: "Assessment - General --> Advance Care",
      REF_KEY: null,
    },
    CHIEF_COMPLAINT: {
      CODE: "CL010.289",
      VALUE: "Chief Complaint",
      DESCRIPTION: "Assessment - General --> Chief Complaint",
      REF_KEY: null,
    },
    DIAGNOSES: {
      CODE: "CL010.303",
      VALUE: "Diagnoses",
      DESCRIPTION: "Assessment - General --> Diagnoses",
      REF_KEY: null,
    },
    EXAMINATION: {
      CODE: "CL010.292",
      VALUE: "Examination",
      DESCRIPTION: "Assessment - General --> Examination",
      REF_KEY: null,
    },
    FAMILY_PATIENT_HISTORY_GRID: {
      CODE: "CL010.297",
      VALUE: "Family Patient History Grid",
      DESCRIPTION: "Assessment - General --> Family Patient History Grid",
      REF_KEY: null,
    },
    GOALS_OF_CARE: {
      CODE: "CL010.290",
      VALUE: "Goals Of Care",
      DESCRIPTION: "Assessment - General --> Goals Of Care",
      REF_KEY: null,
    },
    HISTORY_OF_PRESENT_ILLNESS: {
      CODE: "CL010.293",
      VALUE: "History of Present Illness",
      DESCRIPTION: "Assessment - General --> History of Present Illness",
      REF_KEY: null,
    },
    MEDICAL_PATIENT_HISTORY_GRID: {
      CODE: "CL010.295",
      VALUE: "Medical Patient History Grid",
      DESCRIPTION: "Assessment - General --> Medical Patient History Grid",
      REF_KEY: null,
    },
    PLAN_OF_CARE: {
      CODE: "CL010.294",
      VALUE: "Plan of Care",
      DESCRIPTION: "Assessment - General --> Plan of Care",
      REF_KEY: null,
    },
    REVIEW_OF_SYSTEMS: {
      CODE: "CL010.291",
      VALUE: "Review of Systems",
      DESCRIPTION: "Assessment - General --> Review of Systems",
      REF_KEY: null,
    },
    SOCIAL_PATIENT_HISTORY_GRID: {
      CODE: "CL010.296",
      VALUE: "Social Patient History Grid",
      DESCRIPTION: "Assessment - General --> Social Patient History Grid",
      REF_KEY: null,
    },
  },
  BEREAVEMENT: {
    CODE: "CL010.133",
    VALUE: "Bereavement",
    DESCRIPTION: "Bereavement",
    REF_KEY: null,
    AVAILABLE_SUPPORT: {
      CODE: "CL010.135",
      VALUE: "Available Support",
      DESCRIPTION: "Bereavement --> Available Support",
      REF_KEY: null,
    },
    BEREAVEMENT_ASSESSMENT: {
      CODE: "CL010.134",
      VALUE: "Bereavement Assessment",
      DESCRIPTION: "Bereavement --> Bereavement Assessment",
      REF_KEY: null,
    },
    BEREAVEMENT_RISK: {
      CODE: "CL010.138",
      VALUE: "Bereavement Risk",
      DESCRIPTION: "Bereavement --> Bereavement Risk",
      REF_KEY: null,
    },
    DECLINE: {
      CODE: "CL010.241",
      VALUE: "Decline",
      DESCRIPTION: "Bereavement --> Decline",
      REF_KEY: null,
    },
    FINANCIAL_SECURITY: {
      CODE: "CL010.136",
      VALUE: "Financial Security",
      DESCRIPTION: "Bereavement --> Financial Security",
      REF_KEY: null,
    },
    HOME_LIFE_PROFILE: {
      CODE: "CL010.137",
      VALUE: "Home Life Profile",
      DESCRIPTION: "Bereavement --> Home Life Profile",
      REF_KEY: null,
    },
    NOTES: {
      CODE: "CL010.139",
      VALUE: "Notes",
      DESCRIPTION: "Bereavement --> Notes",
      REF_KEY: null,
    },
  },
  BILLING: {
    ESTABLISHED_PATIENT_HOME: {
      CODE: "CL010.283",
      VALUE: "establishedPatientHome",
      DESCRIPTION: "Billing --> establishedPatientHome",
      REF_KEY: null,
    },
    REMOTE_PATIENT_MONITORING_TELEHEALTH: {
      CODE: "CL010.287",
      VALUE: "RemotePatientMonitoringTelehealth",
      DESCRIPTION: "Billing --> RemotePatientMonitoringTelehealth",
      REF_KEY: null,
    },
    REMOTE_PATIENT_MONITORING_TELEHEALTH_EM: {
      CODE: "CL010.288",
      VALUE: "RemotePatientMonitoringTelehealth(EM)",
      DESCRIPTION: "Billing --> RemotePatientMonitoringTelehealth(EM)",
      REF_KEY: null,
    },
    ADVANCED_CARE_PLANNING: {
      CODE: "CL010.274",
      VALUE: "advancedCarePlanning",
      DESCRIPTION: "Billing --> advancedCarePlanning",
      REF_KEY: null,
    },
    CHRONIC_CARE_MANAGEMENT_STAR: {
      CODE: "CL010.278",
      VALUE: "chronicCareManagementStar",
      DESCRIPTION: "Billing --> chronicCareManagementStar",
      REF_KEY: null,
    },
    COGNITIVE_IMPAIRMENT_ASSESSMENT_AND_CARE_PLANNING: {
      CODE: "CL010.280",
      VALUE: "cognitiveImpairmentAssessmentAndCarePlanning",
      DESCRIPTION: "Billing --> cognitiveImpairmentAssessmentAndCarePlanning",
      REF_KEY: null,
    },
    COVID19: {
      CODE: "CL010.286",
      VALUE: "covid19",
      DESCRIPTION: "Billing --> covid19",
      REF_KEY: null,
    },
    ESTABLISHED_PATIENT_SNFALF: {
      CODE: "CL010.284",
      VALUE: "establishedPatientSnfAlf",
      DESCRIPTION: "Billing --> establishedPatientSnfAlf",
      REF_KEY: null,
    },
    MEDICARE_ANNUAL_WELLNESS_EXAM: {
      CODE: "CL010.277",
      VALUE: "medicareAnnualWellnessExamn",
      DESCRIPTION: "Billing --> medicareAnnualWellnessExamn",
      REF_KEY: null,
    },
    NEW_PATIENT_HOME: {
      CODE: "CL010.282",
      VALUE: "newPatientHome",
      DESCRIPTION: "Billing --> newPatientHome",
      REF_KEY: null,
    },
    NEW_PATIENT_SNFALF: {
      CODE: "CL010.273",
      VALUE: "newPatientSnfAlf",
      DESCRIPTION: "Billing --> newPatientSnfAlf",
      REF_KEY: null,
    },
    PROLONGED_EVALUATION_MANAGEMENT: {
      CODE: "CL010.275",
      VALUE: "prolongedEvaluationManagement",
      DESCRIPTION: "Billing --> prolongedEvaluationManagement",
      REF_KEY: null,
    },
    SMOKING_CESSATION: {
      CODE: "CL010.276",
      VALUE: "smokingCessation",
      DESCRIPTION: "Billing --> smokingCessation",
      REF_KEY: null,
    },
    TRANSITIONAL_CARE_MANAGEMENT: {
      CODE: "CL010.279",
      VALUE: "transitionalCareManagement",
      DESCRIPTION: "Billing --> transitionalCareManagement",
      REF_KEY: null,
    },
  },
  CANCER: {
    CODE: "CL010.318",
    VALUE: "Cancer",
    DESCRIPTION: "Cancer",
    REF_KEY: null,
  },
  CARDIOVASCULAR: {
    CODE: "CL010.50",
    VALUE: "Cardiovascular",
    DESCRIPTION: "Cardiovascular",
    REF_KEY: null,
    ARRHYTHMIAS: {
      CODE: "CL010.224",
      VALUE: "Arrhythmias",
      DESCRIPTION: "Cardiovascular --> Arrhythmias",
      REF_KEY: null,
    },
    BLOOD_PRESSURE: {
      CODE: "CL010.52",
      VALUE: "Blood Pressure",
      DESCRIPTION: "Cardiovascular --> Blood Pressure",
      REF_KEY: null,
    },
    CAPILLARY_REFILL: {
      CODE: "CL010.53",
      VALUE: "Capillary refill",
      DESCRIPTION: "Cardiovascular --> Capillary refill",
      REF_KEY: null,
    },
    DECLINE: {
      CODE: "CL010.231",
      VALUE: "Decline",
      DESCRIPTION: "Cardiovascular --> Decline",
      REF_KEY: null,
    },
    DEFIBRILLATOR: {
      CODE: "CL010.59",
      VALUE: "Defibrillator",
      DESCRIPTION: "Cardiovascular --> Defibrillator",
      REF_KEY: null,
    },
    EDEMA: {
      CODE: "CL010.54",
      VALUE: "Edema",
      DESCRIPTION: "Cardiovascular --> Edema",
      REF_KEY: null,
    },
    EJECTION_FRACTION: {
      CODE: "CL010.55",
      VALUE: "Ejection Fraction",
      DESCRIPTION: "Cardiovascular --> Ejection Fraction",
      REF_KEY: null,
    },
    HEART_FAILURE_HISTORY: {
      CODE: "CL010.58",
      VALUE: "Heart Failure History",
      DESCRIPTION: "Cardiovascular --> Heart Failure History",
      REF_KEY: null,
    },
    HEART_RATE: {
      CODE: "CL010.51",
      VALUE: "Heart Rate",
      DESCRIPTION: "Cardiovascular --> Heart Rate",
      REF_KEY: null,
    },
    HISTORY_OF_MYOCARDIAL_INFARCTION: {
      CODE: "CL010.56",
      VALUE: "History of Myocardial Infarction",
      DESCRIPTION: "Cardiovascular --> History of Myocardial Infarction",
      REF_KEY: null,
    },
    NOTES: {
      CODE: "CL010.62",
      VALUE: "Notes",
      DESCRIPTION: "Cardiovascular --> Notes",
      REF_KEY: null,
    },
    OTHER_ISSUES: {
      CODE: "CL010.61",
      VALUE: "Other Issues",
      DESCRIPTION: "Cardiovascular --> Other Issues",
      REF_KEY: null,
    },
    PACEMAKER: {
      CODE: "CL010.58",
      VALUE: "Pacemaker",
      DESCRIPTION: "Cardiovascular --> Pacemaker",
      REF_KEY: null,
    },
    RISK_FOR_CARDIOPULMONARY_ARREST: {
      CODE: "CL010.60",
      VALUE: "Risk for Cardiopulmonary Arrest",
      DESCRIPTION: "Cardiovascular --> Risk for Cardiopulmonary Arrest",
      REF_KEY: null,
    },
  },
  CHRONIC_CARE_MANAGEMENT_CCM: {
    CODE: "CL010.258",
    VALUE: "Chronic Care Management (CCM)*",
    DESCRIPTION: "Chronic Care Management (CCM)*",
    REF_KEY: null,
  },
  POST_MORTEM_ENCOUNTER_DEATH_ASSESSMENT: {
    ASSESSMENT_OF_DEATH: {
      CODE: "CL010.312",
      VALUE: "Assessment of Death",
      DESCRIPTION: "Death Assessment --> Assessment of Death",
      REF_KEY: null,
    },
    FAMILY_AND_BEREAVEMENT_SUPPORT: {
      CODE: "CL010.313",
      VALUE: "Family and Bereavement Support",
      DESCRIPTION: "Death Assessment --> Family and Bereavement Support",
      REF_KEY: null,
    },
    NOTIFICATIONS: {
      CODE: "CL010.314",
      VALUE: "Notifications",
      DESCRIPTION: "Death Assessment --> Notifications",
      REF_KEY: null,
    },
    PATIENT_INFORMATION: {
      CODE: "CL010.311",
      VALUE: "Patient Information",
      DESCRIPTION: "Death Assessment --> Patient Information",
      REF_KEY: null,
    },
  },
  DEMENTIA: {
    CODE: "CL010.321",
    VALUE: "Dementia",
    DESCRIPTION: "Dementia",
    REF_KEY: null,
  },
  EXTERNAL_FACE_TO_FACE_VISIT: {
    CODE: "CL010.315",
    VALUE: "External Face to Face Visit",
    DESCRIPTION: "External Face to Face Visit",
    REF_KEY: null,
  },
} as const;

// Role Codes (SD002.x)
export const CLINICAL_ROLE_SD002_CODES = {
  CASE_MANAGER: {
    CODE: "SD002.1",
    VALUE: "Case Manager",
    DESCRIPTION: "Case Manager",
    REF_KEY: null,
  },
  TEAM_LEAD: {
    CODE: "SD002.2",
    VALUE: "Team Lead",
    DESCRIPTION: "Team Lead",
    REF_KEY: null,
  },
  REGISTERED_NURSE_RN: {
    CODE: "SD002.3",
    VALUE: "Registered Nurse (RN)",
    DESCRIPTION: "Registered Nurse (RN)",
    REF_KEY: null,
  },
  NURSE_PRACTITIONER: {
    CODE: "SD002.4",
    VALUE: "Nurse Practitioner",
    DESCRIPTION: "Nurse Practitioner",
    REF_KEY: null,
  },
  SOCIAL_WORKER: {
    CODE: "SD002.7",
    VALUE: "Social Worker",
    DESCRIPTION: "Social Worker",
    REF_KEY: null,
  },
  MEDICAL_DIRECTOR: {
    CODE: "SD002.10",
    VALUE: "Medical Director",
    DESCRIPTION: "Medical Director",
    REF_KEY: null,
  },
  VOLUNTEER_COORDINATOR: {
    CODE: "SD002.12",
    VALUE: "Volunteer Coordinator",
    DESCRIPTION: "Volunteer Coordinator",
    REF_KEY: null,
  },
  LPN_LVN_NURSE: {
    CODE: "SD002.11",
    VALUE: "LPN/LVN Nurse",
    DESCRIPTION: "LPN/LVN Nurse",
    REF_KEY: null,
  },
  SPIRITUAL_CARE: {
    CODE: "SD002.8",
    VALUE: "Spiritual Care",
    DESCRIPTION: "Spiritual Care",
    REF_KEY: null,
  },
  BEREAVEMENT: {
    CODE: "SD002.9",
    VALUE: "Bereavement",
    DESCRIPTION: "Bereavement",
    REF_KEY: null,
  },
  HOSPICE_AIDE: {
    CODE: "SD002.5",
    VALUE: "Hospice Aide",
    DESCRIPTION: "Hospice Aide",
    REF_KEY: null,
  },
  HOMEMAKER: {
    CODE: "SD002.6",
    VALUE: "Home Maker",
    DESCRIPTION: "Home Maker",
    REF_KEY: null,
  },
  VOLUNTEER: {
    CODE: "SD002.13",
    VALUE: "Volunteer",
    DESCRIPTION: "Volunteer",
    REF_KEY: null,
  },
} as const;



// WEBPACK FOOTER //
// ./src/configs/clinical-codes.constants.ts